import { render, staticRenderFns } from "./VsRouterRedirect.vue?vue&type=template&id=dbdaee6e&lang=pug&"
import script from "./VsRouterRedirect.vue?vue&type=script&lang=js&"
export * from "./VsRouterRedirect.vue?vue&type=script&lang=js&"
import style0 from "./VsRouterRedirect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbdaee6e')) {
      api.createRecord('dbdaee6e', component.options)
    } else {
      api.reload('dbdaee6e', component.options)
    }
    module.hot.accept("./VsRouterRedirect.vue?vue&type=template&id=dbdaee6e&lang=pug&", function () {
      api.rerender('dbdaee6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsRouterRedirect.vue"
export default component.exports